<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			d="M5 20V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V20"
			fill="#E9E9E9"
		/>
		<path
			d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
			fill="#E9E9E9"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.25 8C7.25 5.37665 9.37665 3.25 12 3.25C14.6233 3.25 16.75 5.37664 16.75 8C16.75 9.55029 16.0073 10.9271 14.8583 11.7941C17.7239 12.9317 19.75 15.7292 19.75 19V20C19.75 20.4142 19.4142 20.75 19 20.75H5C4.58579 20.75 4.25 20.4142 4.25 20V19C4.25 15.7293 6.27613 12.9317 9.14173 11.7941C7.99271 10.9271 7.25 9.55029 7.25 8ZM12 12.75C8.54822 12.75 5.75 15.5482 5.75 19V19.25H18.25V19C18.25 15.5482 15.4518 12.75 12 12.75ZM12 4.75C10.2051 4.75 8.75 6.20507 8.75 8C8.75 9.79489 10.2051 11.25 12 11.25C13.7949 11.25 15.25 9.79489 15.25 8C15.25 6.20508 13.7949 4.75 12 4.75Z"
			fill="#E9E9E9"
		/>
	</svg>
</template>
